export const blockIconsSearchManageSearch = (
	<span className='material-symbols-outlined'>manage_search</span>
);
